/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import { useHistory } from 'react-router';

import { Severity, withSnackbar } from '../Snackbar/Snackbar';
import PdfListButton from '../PdfListButton/PdfListButton';
import DownloadButton from '../DownloadButton/DownloadButton';
import GlobalLoader from '../GlobalLoader/GlobalLoader';

import AdminService from '../../core/services/admin-api-service';

import redirectIfUnauthorized from '../../core/helpers/redirect-if-unauthorized';

import './Actions.scss';

const apiService = new AdminService();

interface IActions {
  showSnackbar: (msg: string, sev?: Severity, dur?: number) => void;
}

function Actions({ showSnackbar }: IActions): JSX.Element {
  const history = useHistory();
  const [pending, setPending] = useState<boolean>(false);

  const publish = () => {
    if (!window.confirm('Please confirm')) {
      return;
    }

    setPending(true);
    apiService
      .publish()
      .then(() => {
        showSnackbar(`Published with success`);
        setPending(false);
      })
      .catch((err) => {
        console.error(err);
        showSnackbar(`Failed to publish`, Severity.ERROR);
        setPending(false);

        redirectIfUnauthorized(err, history);
      });
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const uploadData = (event: any) => {
    event.preventDefault();
    const formData = new FormData();
    formData.append('files', event.target.files[0]);

    // eslint-disable-next-line no-param-reassign
    event.target.value = '';
    setPending(true);
    apiService
      .uploadData(formData)
      .then(() => {
        setPending(false);
        showSnackbar(`Uploaded with success`);
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      })
      .catch((err) => {
        showSnackbar(`Failed to upload`, Severity.ERROR);
        setPending(false);
        console.error(err);

        redirectIfUnauthorized(err, history);
      });
  };

  return (
    <div className="Actions pdf-exclude">
      <div className="mx-2">
        <button className="emp-btn" type="button" onClick={publish}>
          <span className="button-text">Publish</span>
        </button>
      </div>

      <div className="mx-2">
        <DownloadButton />
      </div>

      <div className="mx-2">
        <PdfListButton />
      </div>

      <div className="Actions__upload mx-2">
        <button className="emp-btn" type="button">
          <span className="button-text">Upload Data</span>
        </button>
        <input
          type="file"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          onChange={uploadData}
        />
      </div>
      {pending ? <GlobalLoader /> : null}
    </div>
  );
}

export default withSnackbar(Actions);
